import { useParams } from "react-router-dom";
import camisas from "../data/camisas";
export default function CamisaDetalhe() {
  const { id } = useParams();

  const camisa = camisas.find((c) => c.id === Number(id));

  if (!camisa) return <p>Camisa não encontrada</p>;

  return (
    <div className="detalhe">
      <img src={camisa.imagem} alt={camisa.nome} />
      <h2>{camisa.nome}</h2>
      <p>{camisa.descricao}</p>
    </div>
  );
}

